import { Dropdown, Input, Table } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../assets/svg/svg27.svg";
import DeleteModal from "../../components/DeleteModal";
import svg38 from "../../assets/svg/svg38.svg";
import svg56 from "../../assets/svg/svg56.svg";
import MaterialIcon from "material-icons-react";
import FilterModal from "./modal/FilterModal";
import AddEntriesModal from "./modal/AddEntriesModal";
import InsideHeader from "../../components/InsideHeader";
import NoDataTable from "../../components/NoDataTable";
import { fetchAttendanceEntries } from "../../features/dropdown/dropdownSlice";
import { deleteAttendance } from "../../features/staff-setting/staffSettingSlice";
import { dateForHumans } from "../../utils";
import { setAttendanceHeaderObj } from "../../features/folder/folderSlice";
import HowToAddAttendanceEntriesModal from "./modal/HowToAddAttendanceEntriesModal";
import DailyRateModal from "./modal/DailyRateModal";

export default function AttendanceEntriesTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { attendanceEntries, attendanceEntriesCount, loading } = useSelector(
    (state) => state.dropdown
  );

  const { staffloading } = useSelector((state) => state.staff);

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }
 
  const [openDailyRate, setopenDailyRate] = useState(false);

  const handleCancelDailyRate = () => {
    setopenDailyRate(false);
  };
  const handleDailyRate = () => {
    setopenDailyRate(true);
  };

  const [openHow, setopenHow] = useState(false);
  function handleCancelHow() {
    setopenHow(false);
  }

  async function handleAdd() {
    await setopen(true);
  }
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const [prodd, setProdd] = useState("");

  async function handleFolderChange() {
    await dispatch(setAttendanceHeaderObj(prodd));
    await navigate(`/attendance-details`);
  }

  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      deleteAttendance({
        attId: prodd?.attId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetch();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleAddEntries = async () => {
    await setopenHow(true);
    await setProdd("");
  };

  const handleEdit = () => {
    setopen(true);
  };

  async function handleUploadFile() {
    await navigate("/attendance/add/file-upload");
  }


  const settingItemsQuickActions = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleAddEntries}
          className="flex  text-[16px] font-sans  !text-lightBlack py-1"
        >
          Add Attendance Entries
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleDailyRate}
          className="flex  text-[16px] font-sans  !text-lightBlack py-1"
        >
          Daily Rate Process
        </Link>
      ),
    },
    
  ];

  const settingItems = [
    {
      key: "0",
      label: (
        <Link
          onClick={handleFolderChange}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Details
        </Link>
      ),
    },
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },

    {
      key: "2",
      label: (
        <div
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans   !text-lightBlack"
        >
          Delete
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "Personnel Name",
      dataIndex: "ppFullname",
      sorter: (a, b) => a.ppFullname.localeCompare(b.ppFullname),
    },
    {
      title: "Personnel No",
      dataIndex: "ppPfno",
      sorter: (a, b) => a.ppPfno.localeCompare(b.ppPfno),
    },
    {
      title: "Attendance Type",
      dataIndex: "attType",
      sorter: (a, b) => a.attType.localeCompare(b.attType),
    },

    {
      title: "Attendance Date",
      dataIndex: "attDate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      sorter: (a, b) => a.attDate.localeCompare(b.attDate),
    },
    {
      title: "CheckIn Time",
      dataIndex: "checkInTime",
      sorter: (a, b) => a.checkInTime.localeCompare(b.checkInTime),
    },
    {
      title: "CheckOut Time",
      dataIndex: "checkOutTime",
      sorter: (a, b) => a.checkOutTime.localeCompare(b.checkOutTime),
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchAttendanceEntries());
    await setFilters([]);
  };
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function handleFetch(page, size) {
    dispatch(
      fetchAttendanceEntries({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    handleFetch();
  }, []);

  return (
    <div className="w-full overflow-y-scroll h-full">
      <InsideHeader
        title="Attendance Entries"
        subtitle="Manage attendance entries within your institution"
        back={false}
      />
      <div className="lg:px-10 px-3">
        {attendanceEntries && attendanceEntries?.length > 0 ? (
          <>
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Attendance Entries Details
            </h3>
            <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
              <div className="flex items-center">
                <span>
                  {" "}
                  <button
                    onClick={showModalFilter}
                    type="button"
                    className={`bg-transparent flex items-center gap-x-'1' ${
                      Object?.keys(formData)?.length > 0
                        ? "!text-[#5688E5]"
                        : "inherit"
                    }`}
                  >
                    <MaterialIcon color="#141414" icon="filter_list" />
                    Filters
                  </button>
                </span>
                {Object?.keys(formData)?.length > 0 && (
                  <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                    :{Object?.keys(formData)?.length}
                    <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                  </span>
                )}
              </div>
              <div className="flex lg:flex-row flex-col lg:items-center items-start lg:gap-x-10 gap-y-5">
              <Dropdown
                  overlayStyle={{
                    width: "250px",
                  }}
                  trigger={"click"}
                  menu={{ items: settingItemsQuickActions }}
                  placement="bottom"
                >
                  <div className="w-[200px]">
                    <button className="cstm-btn flex gap-x-2" type="submit">
                      <img src={svg56} alt={svg56} /> Quick actions
                    </button>
                  </div>
                </Dropdown> 
              </div>
            </div>

            <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
              <section>
                <Table
                  rowSelection={false}
                  className="mt-[1.31rem] w-full"
                  scroll={{
                    x: 800,
                  }}
                  rowKey={(record) => record?.attId}
                  columns={columns}
                  dataSource={attendanceEntries}
                  loading={loading}
                  pagination={{
                    position: ["bottomCenter"],
                    current: pageIndex + 1,
                    total: attendanceEntriesCount,
                    pageSize: pageSize,
                    onChange: (page, size) => {
                      setPageIndex(page - 1);
                      setPageSize(size);
                      handleFetch(page - 1, size);
                    },
                    showSizeChanger: false,
                    hideOnSinglePage: true,
                  }}
                />
              </section>
            </div>
          </>
        ) : (
          <NoDataTable
            title="Create attendance entry to organise your casuals"
            imgTitle="Attendance entry will appear here once added"
            btnTile="Create attendance entry"
            handleAddFolder={handleAdd}
          />
        )}
      </div>
      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete entry for ${prodd?.ppFullname}?`}
        title={`Remove ${prodd?.ppFullname}`}
      />

      <AddEntriesModal
        handleFetchData={handleFetch}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />

      <HowToAddAttendanceEntriesModal
        handleFetchData={handleFetch}
        uploadAttendanceFile={handleUploadFile}
        open={openHow}
        handleCancel={handleCancelHow}
      />

      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
      />
        <DailyRateModal
        handleFetchData={handleFetch}
        open={openDailyRate}
        handleCancel={handleCancelDailyRate}
        prodd={prodd}
      />
    </div>
  );
}
